import { MarriagePersonDetails } from "@/models"
import { css } from "vite-css-in-js"
import { defineComponent, type ReactiveComponent } from "vue-utils"
import { useEditingMarriageClaimState } from "../state"
import { isEmptyStringOrNull } from "./utils"

const formSectionStyling = css`
	display: grid;
	align-items: center;
	grid-template-columns: repeat(2, 1fr);
	gap: 0.5rem 2rem;

	h6 {
		margin-bottom: 0;
	}

	@media (width < 992px) {
		grid-template-columns: 1fr;
	}
`

const ClaimantInformation: ReactiveComponent = () => {
	const state = useEditingMarriageClaimState()

	return () =>
		Object.keys(state.fullClaim.Details).filter(
			(key) => state.fullClaim.Details[key as keyof MarriagePersonDetails] !== null
		).length === 0 ? (
			<h5>No Claimant Information</h5>
		) : (
			<div class={formSectionStyling}>
				<div class="d-flex gap-1">
					<h6>Title:</h6>
					<h6 class="fw-bold">
						{isEmptyStringOrNull(state.fullClaim.Details.Title) ? `Unknown` : state.fullClaim.Details.Title}
					</h6>
				</div>
				<div class="d-flex gap-1">
					<h6>Gender:</h6>
					<h6 class="fw-bold">{state.fullClaim.Details.Gender ?? `Unknown`}</h6>
				</div>
				<div class="d-flex gap-1">
					<h6>First Name:</h6>
					<h6 class="fw-bold">
						{isEmptyStringOrNull(state.fullClaim.Details.FirstName) ? `Unknown` : state.fullClaim.Details.FirstName}
					</h6>
				</div>
				<div class="d-flex gap-1">
					<h6>Mobile Number:</h6>
					<h6 class="fw-bold">
						{isEmptyStringOrNull(state.fullClaim.Details.Mobile) ? `Unknown` : state.fullClaim.Details.Mobile}
					</h6>
				</div>
				<div class="d-flex gap-1">
					<h6>Last Name:</h6>
					<h6 class="fw-bold">
						{isEmptyStringOrNull(state.fullClaim.Details.LastName) ? `Unknown` : state.fullClaim.Details.LastName}
					</h6>
				</div>
				<div class="d-flex gap-1">
					<h6>NI Number:</h6>
					<h6 class="fw-bold">
						{isEmptyStringOrNull(state.fullClaim.Details.NINumber) ? `Unknown` : state.fullClaim.Details.NINumber}
					</h6>
				</div>
				<div class="d-flex gap-1">
					<h6>Email:</h6>
					<h6 class="fw-bold">
						{isEmptyStringOrNull(state.fullClaim.Details.Email) ? `Unknown` : state.fullClaim.Details.Email}
					</h6>
				</div>
				<div class="d-flex gap-1">
					<h6>Birth Date:</h6>
					<h6 class="fw-bold">
						{state.fullClaim.Details.BirthDate !== null ? state.fullClaim.Details.BirthDate.toGBString() : `Unknown`}
					</h6>
				</div>
			</div>
		)
}

export default defineComponent(ClaimantInformation)
